module.exports = __webpack_public_path__ + "img/Frame12.8602fe1b.png";